import {defaultVolumeRatio} from "./getData";

export const cache = {
  _msg: "",//登录用户信息
  _storage: "",//仓库信息
  _outDeviceModel: 0,//外接设备 1 磅秤仪器 2 体积重仪器 3 DWS仪器
  _volumeRatio: '',//体积率
  _storeList: [],//账户关联仓库列表
  _weightSetting: null,//串口磅秤连接设置信息
  _needRefreshStorage: false,//需要刷新仓库操作
  _printerIp: "",//默认打印机地址
  _printerId: "",//默认打印机id
  _appendCode: "",//快递单号/转运单号截取长度 从首部开始截取
  _previewPrint: false,//预览打印

  set msg(userInfo) {
    if (userInfo) {
      this._msg = userInfo;
      userInfo = encodeURIComponent(JSON.stringify(userInfo));
      window.sessionStorage.setItem("MSG", userInfo);
    } else {
      window.sessionStorage.removeItem("MSG");
      this._msg = "";
    }
  },

  get msg() {
    if (!this._msg) {
      let msg = decodeURIComponent(window.sessionStorage.getItem("MSG"));
      if (msg) {
        this._msg = JSON.parse(msg);
      }
    }
    return this._msg;
  },

  set storeList(storeList) {
    if (storeList) {
      this._storeList = storeList;
      storeList = encodeURIComponent(JSON.stringify(storeList))
      window.sessionStorage.setItem("STORAGE_LIST", storeList);
    } else {
      window.sessionStorage.removeItem("STORAGE_LIST");
      this._storeList = "";
    }
  },

  get storeList() {
    if (this._storeList.length === 0) {
      let storeList = decodeURIComponent(window.sessionStorage.getItem("STORAGE_LIST"));
      if (storeList) {
        this._storeList = JSON.parse(storeList);
      }
    }
    return this._storeList;
  },

  set storage(storage) {
    if (storage) {
      this._storage = storage;
      storage = encodeURIComponent(JSON.stringify(storage))
      window.sessionStorage.setItem("STORAGE", storage);
    } else {
      window.sessionStorage.removeItem("STORAGE");
      this._storage = "";
    }
  },

  get storage() {

    if (!this._storage) {
      let storage = decodeURIComponent(window.sessionStorage.getItem("STORAGE"));
      if (storage) {
        this._storage = JSON.parse(storage);
      }
    }
    return this._storage;
  },

  set outDeviceModel(outDeviceModel) {
    window.localStorage.setItem("DEVICE_MODEL", outDeviceModel);
    this._outDeviceModel = outDeviceModel;
  },

  get outDeviceModel() {
    if (!this._outDeviceModel) {
      if (window.localStorage.getItem("outDeviceModel")) {
        let outDeviceModel = window.localStorage.getItem("outDeviceModel")
        window.localStorage.setItem("DEVICE_MODEL", outDeviceModel);
        this._outDeviceModel = Number(outDeviceModel);
        window.localStorage.removeItem("outDeviceModel")
      } else {
        this._outDeviceModel = Number(window.localStorage.getItem("DEVICE_MODEL") || '0');
      }
    }
    return this._outDeviceModel;
  },

  set weightSetting(weightSetting) {
    this._weightSetting = weightSetting;
    weightSetting = encodeURIComponent(JSON.stringify(weightSetting))
    window.localStorage.setItem("WEIGHT_SETTING", weightSetting);
  },

  get weightSetting() {
    if (!this._weightSetting) {
      if (window.localStorage.getItem("weightSetting")) {
        let weightSetting = window.localStorage.getItem("weightSetting");
        window.localStorage.setItem("WEIGHT_SETTING", encodeURIComponent(weightSetting));
        this._weightSetting = JSON.parse(weightSetting);
        window.localStorage.removeItem("weightSetting")
      } else {
        let weightSetting = decodeURIComponent(window.localStorage.getItem("WEIGHT_SETTING"));
        if (weightSetting) {
          this._weightSetting = JSON.parse(weightSetting);
        }
      }
    }
    return this._weightSetting;
  },

  set printerIp(printerIp) {
    this._printerIp = printerIp;
    printerIp = encodeURIComponent(printerIp)
    window.localStorage.setItem("PRINTER_IP", printerIp);
  },

  get printerIp() {
    if (!this._printerIp) {
      if (window.localStorage.getItem("PRINTER_IP")) {
        let printerIp = decodeURIComponent(window.localStorage.getItem("PRINTER_IP"));
        if (printerIp) {
          this._printerIp = printerIp;
        }
      }
    }
    return this._printerIp;
  },

  set printerId(printerId) {
    this._printerId = printerId;
    printerId = encodeURIComponent(printerId)
    window.localStorage.setItem("PRINTER_ID", printerId);
  },

  get printerId() {
    if (!this._printerId) {
      if (window.localStorage.getItem("PRINTER_ID")) {
        let printerId = decodeURIComponent(window.localStorage.getItem("PRINTER_ID"));
        if (printerId) {
          this._printerId = printerId;
        }
      }
    }
    return this._printerId;
  },

  set volumeRatio(volumeRatio) {
    this._volumeRatio = volumeRatio;
    window.localStorage.setItem("VOLUME_RATIO", volumeRatio);
  },

  get volumeRatio() {
    if (!this._volumeRatio) {
      if (window.localStorage.getItem("VOLUME_RATIO")) {
        let volumeRatio = window.localStorage.getItem("VOLUME_RATIO");
        if (volumeRatio) {
          this._volumeRatio = volumeRatio;
        }
      }
    }
    return this._volumeRatio || defaultVolumeRatio;
  },

  set appendCode(appendCode) {
    if (!appendCode) {
      appendCode = "";
    }
    this._appendCode = appendCode;
    window.localStorage.setItem("APPEND_CODE", appendCode);
  },

  get appendCode() {
    if (!this._appendCode) {
      if (window.localStorage.getItem("APPEND_CODE")) {
        let appendCode = window.localStorage.getItem("APPEND_CODE");
        if (appendCode) {
          this._appendCode = appendCode;
        }
      }
    }
    return this._appendCode || "";
  },

  set needRefreshStorage(needRefreshStorage) {
    this._needRefreshStorage = needRefreshStorage;
    if (needRefreshStorage) {
      window.sessionStorage.setItem("NEED_REFRESH_STORAGE", needRefreshStorage);
    } else {
      window.sessionStorage.removeItem("NEED_REFRESH_STORAGE")
    }
  },

  get needRefreshStorage() {
    this._needRefreshStorage = !!window.sessionStorage.getItem("NEED_REFRESH_STORAGE");
    return this._needRefreshStorage;
  },

  set previewPrint(previewPrint) {
    if (previewPrint) {
      window.localStorage.setItem("PREVIEW_PRINT", previewPrint)
    } else {
      window.localStorage.removeItem("PREVIEW_PRINT")
    }
    this._previewPrint = previewPrint
  },

  get previewPrint() {
    this._previewPrint = !!window.localStorage.getItem("PREVIEW_PRINT");
    return this._previewPrint
  },

  removeAllInfo: function () {
    window.sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/api/localCache.js